import React from 'react';
import { Col, Container } from 'react-bootstrap';

export default function Fallback() {
  return (
    <>
      <Container
        fluid
        style={{
          marginTop: '200px',
          marginBottom: '200px',
          maxWidth: '800px',
          textAlign: 'center',
        }}
      >
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src='logo.png' style={{ width: '120px' }} />
          <h1
            style={{
              width: '100%',
              textAlign: 'center',
              marginTop: '2rem',
              fontSize: '30px',
              fontWeight: '300',
              fontFamily: 'Montserrat, sans-serif',
              marginBottom: '2rem',
            }}
          >
            EliteCloud Dashboard Beta Trial
          </h1>
          <p>Thank you for being part of our EliteCloud beta trial.</p>
          <p>
            Your feedback has now been verified & is currently being implemented by our engineers in
            preparation for official release.
          </p>
          <p>
            If you would like to continue to support us with dashboard testing & feedback, please
            email <a href='mailto:prerelease@aap.co.nz'>prerelease@aap.co.nz</a> with your company
            name & EliteCloud account details.
          </p>
          <p>Again, thank you very much for your support.</p>
          <br />
        </Col>
      </Container>
    </>
  );
}
